import React from "react";
import { Link } from "react-router-dom";
import { FiGlobe } from "react-icons/fi";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        {/* Column 1: Customer care */}
        <div className="footer-col member-col">
          <h3>CUSTOMER CARE</h3>
          <p className="member-desc">Questions about an item or order? Our team is here to help.</p>
          <a href="mailto:shop@ovahorizon.online" className="btn-create-account">EMAIL US</a>
        </div>

        {/* Column 2: Brand */}
        <div className="footer-col">
          <h3>OVAHORIZON</h3>
          <ul>
            <li>
              <Link to="/about" onClick={toTop}>
                Our brand
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Help */}
        <div className="footer-col">
          <h3>HELP</h3>
          <ul>
            <li>
              <Link to="/contact" onClick={toTop}>
                Customer service
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Delivery
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns
              </Link>
            </li>

            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/cookies" onClick={toTop}>
                Cookie policy
              </Link>
            </li>
            <li>
              <Link to="/faqs" onClick={toTop}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/terms" onClick={toTop}>
                Terms & conditions
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="bottom-left">
          <div className="logo-bottom">
            <span className="brand-name">OVAHORIZON</span>
            <span className="tagline">made for every horizon</span>
          </div>
        </div>
        <div className="bottom-center">
          <p>
            Customer care: shop@ovahorizon.online · Fredskovvej 5,
            DK-7330 Brande
          </p>
          <p>© 2026 Ovahorizon. All rights reserved.</p>
          <div className="payment-methods" aria-label="Supported payment methods">
            <span>VISA</span><span>Mastercard</span><span>AMEX</span><span>Discover</span>
          </div>
        </div>
        <div className="bottom-right">
          <button className="country-selector">
            <FiGlobe size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
